export default {
  methods: {
    selectDisciplineCategoryOptions(dis) {
      let category = null;
      if (dis === "Business") {
        category = this.listBusiness;
      } else if (dis === "Civil") {
        category = this.listCivil;
      } else if (dis === "Comms") {
        category = this.listTelecommunications;
      } else if (dis === "Control") {
        category = this.listControl;
      } else if (dis === "Electrical") {
        category = this.listElectrical;
      } else if (dis === "Environment") {
        category = this.listEnvionment;
      } else if (dis === "Finance") {
        category = this.listFinance;
      } else if (dis === "Fire") {
        category = this.listFire;
      } else if (dis === "General") {
        category = this.listGeneral;
      } else if (dis === "Instrumentation") {
        category = this.listInstrumentation;
      } else if (dis === "IT") {
        category = this.listIt;
      } else if (dis === "Mechanical") {
        category = this.listMechanical;
      } else if (dis === "Mechanical") {
        category = this.listMechanical;
      } else if (dis === "Process") {
        category = this.listProcess;
      } else if (dis === "Machine") {
        category = this.listMachine;
      } else if (dis === "Sensor") {
        category = this.listInstrumentation;
      } else if (dis === "Safety") {
        category = this.listSafety;
      } else if (dis === "System") {
        category = this.listSystem;
      } else if (dis === "Telecommunications") {
        category = this.listTelecommunications;
      } else {
        category = [];
      }
      return category;
    }
  },
  data() {
    return {
      engineeringType: [],
      // Disciplines
      listElectrical: [
        "Battery",
        "Cable",
        "Control",
        "Protection",
        "Test Equipment",
        "General",
        "Generator",
        "Heater",
        "Lighting",
        "Motor",
        "Power Conversion",
        "Power Transmission and Distribution",
        "Switchgear",
        "Transformer"
      ],
      // eslint-disable-next-line
      listRotating: [
        "Components",
        "Compressor",
        "Engine",
        "Gearbox",
        "Process",
        "Pump",
        "Turbine"
      ],
      // eslint-disable-next-line
      listSafety: [
        "Machine",
        "Personal",
        "Process"
      ],
      // eslint-disable-next-line
      listMachine: [
        "Crush",
        "Compress",
        "Crane",
        "Drill",
        "Engine",
        "Filter",
        "Generate",
        "Grind",
        "Mill",
        "Move",
        "Package",
        "Process",
        "Press",
        "Pump",
        "Test"
      ],
      // eslint-disable-next-line
      listInstrumentation: [
        "Analyser",
        "Flowmeter",
        "Gauge",
        "Level",
        "Transmitter",
        "Safety",
        "Switch",
        "Valve"
      ],
      // eslint-disable-next-line
      listMechanical: [
        "Accumulator",
        "Corrosion",
        "Crane",
        "Filter",
        "Flare",
        "Heater",
        "Heat Exchanger",
        "Hose",
        "HVAC",
        "Pipe",
        "Tank",
        "Vessel",
        "Valve"
      ],
      // eslint-disable-next-line
      listControl: [
        "APC",
        "DCS",
        "PLC",
        "Machine",
        "Remote",
        "Safety",
        "SCADA",
        "Miscellaneous"
      ],
      // eslint-disable-next-line
      listBusiness: [
        "Accounting",
        "Finance",
        "HR",
        "Logistics",
        "Order"
      ],
      // eslint-disable-next-line
      listFinance: [
        "Credit",
        "Debt",
        "Investment"
      ],
      // eslint-disable-next-line
      listEnvionment: [
        "Emissions",
        "General",
        "Marine",
        "Spill"
      ],
      // eslint-disable-next-line
      listCivil: [
        "Building",
        "Hydraulic",
        "Structural",
        "Transportation"
      ],
      // eslint-disable-next-line
      listIt: [
        "Hardware",
        "Network",
        "Software"
      ],
      // eslint-disable-next-line
      listFire: [
        "AFS",
        "Fire Extinguisher",
        "PFS"
      ],
      // eslint-disable-next-line
      listGeneral: [
        "System",
        "Package",
        "Unit",
        "Component"
      ],
      // eslint-disable-next-line
      listProcess: [
        "Gas",
        "Fuel",
        "Power",
        "System",
        "Water"
      ],
      // eslint-disable-next-line
      listTelecommunications: [
        "Antenna",
        "Aux",
        "Radio",
        "Phone",
        "Navigation",
        "Security"
      ],
      // eslint-disable-next-line
      listSystem: [
        "Mobile",
        "Package",
        "Safety"
      ],
      // eslint-disable-next-line
      electricalBattery: [
        "Alkaline",
        "Button Cell",
        "LA AGM",
        "LA Gel",
        "LA Wet",
        "Li-ion",
        "NiCd Block",
        "VRLA"
      ],
      electricalCable: [
        "Extra HV",
        "HV",
        "Instrumentation ",
        "LV",
        "Optical Fibres"
      ],
      electricalHeater: [
        "Anti-Condensation",
        "Inductive",
        "Infrared",
        "Oven",
        "Panel",
        "Porcelain",
        "Resistive",
        "Underfloor",
        "U Type"
      ],
      electricalControl: [
        "Alarm System",
        "Annunciator Panel",
        "AVR",
        "Electrical Panel",
        "Control Panel",
        "Engine Control",
        "ENMS",
        "Generator Control",
        "Governor",
        "GPS Clock Panel",
        "HMI",
        "IP",
        "PMS",
        "PQM",
        "Remote Control",
        "RCU",
        "Remote Switching",
        "RTU",
        "Substation Automation"
      ],
      electricalProtection: [
        "Digital Relay",
        "Electromechanical Relay",
        "IED",
        "Pilot Wire to Optical Converter",
        "Pilot Wire System",
        "MCC Relay",
        "Static Relay",
        "UV Relay"
      ],
      electricalTest: [
        "Defibrillator",
        "Discharge Stick",
        "HV Test Stick",
        "HV Mats",
        "HV Rescue Kit",
        "LV Rescue Kit",
        "Arc Switching Gear",
        "Multimeter",
        "Portable Earth"
      ],
      electricalGeneral: [
        "Earth Electrode",
        "Earth Electrode Tank",
        "Earth Electrode Tower",
        "Earth Electrode Vessel",
        "Emergency PB",
        "JB Multi.",
        "JB Single",
        "Pushbutton",
        "RCU",
        "Reset Switch",
        "Safety Switch"
      ],
      electricalGenerator: [
        "DC Generator",
        "Exciter",
        "Synchronous Generator",
        "Asynchronous Generator",
        "PD Couplers",
        "Surge Arrestor"
      ],
      electricalLight: [
        "Lighting DB",
        "LED",
        "Fluorescent",
        "Flood Light",
        "Local JB",
        "Main JB",
        "Light Pole",
        "Photocell",
        "Surge Arrestor"
      ],
      electricalMotor: [
        "Exciter",
        "HV AC",
        "LV AC",
        "HV DC",
        "LV DC",
        "Two Speed",
        "Synchronous"
      ],
      electricalPowerConversion: [
        "Active HF",
        "Battery Charger",
        "BESS",
        "HVDC",
        "FACTS",
        "Capacitor",
        "Inductor",
        "LCI Drive",
        "Line Filter",
        "Passive HF",
        "PF Correction",
        "Resistor",
        "Static Switch",
        "VSI Drive",
        "VSD",
        "UPS"
      ],
      electricalTransmissionDist: [
        "Recloser",
        "Sectionaliser",
        "Line Isolator",
        "Pole Concrete",
        "Pole Steel",
        "Pole Wood",
        "HV Tower",
        "EHV Tower",
        "DC Tower",
        "Railway Tower",
        "Fault Indictor",
        "Earth Electrode",
        "CT",
        "VT",
        "CVT",
        "CTVT",
        "Substation",
        "Switch Yard",
        "Sureg Arrester"
      ],
      electricalSwitchgear: [
        "AIS",
        "GIS (SF6)",
        "DB",
        "HV SB",
        "LV SB",
        "3P Disconnector",
        "HV Circuit Breaker",
        "HV Contactor",
        "HV Feeder",
        "HV Incomer",
        "LV Isolator",
        "LV Circuit Breaker",
        "LV Contactor",
        "LV Feeder",
        "LV Incomer",
        "LV Isolator",
        "MCB",
        "Earth Bar",
        "Earth Electrode",
        "Earth Switch",
        "Feeder",
        "Incomer",
        "Starter",
        "HV Feeder",
        "HV Incomer",
        "HV Starter",
        "LV Feeder",
        "LV Incomer",
        "LV Starter",
        "CT",
        "VT",
        "CVT",
        "CTVT",
        "Surge Arrester"
      ],
      electricalTransformer: [
        "Dry Type",
        "Oil ONAN",
        "Oil ONAF",
        "Oil OFAF",
        "Oil OFWF",
        "Zig Zag",
        "Onload TC",
        "Offload TC",
        "Control Panel",
        "Online DGA",
        "PRV",
        "Buchholz Relay",
        "RTD Box",
        "OTI",
        "WTI",
        "Neutral Earthing Reactor",
        "Neutral Earthing Resistor",
        "Transformer Yard"
      ],
      rotatingCompressor: [
        "Axial",
        "Centrifugal",
        "Reciprocating",
        "Rotary",
        "Screw"
      ],
      // eslint-disable-next-line
      rotatingGear: [
        "High Speed",
        "Low Speed",
        "Standard"
      ],
      // eslint-disable-next-line
      rotatingComponents: [
        "Strainer"
      ],
      // eslint-disable-next-line
      rotatingEngine: [
        "Diesel",
        "Jet",
        "Gas",
        "Petrol"
      ],
      // eslint-disable-next-line
      rotatingTurbine: [
        "Gas (Aero)",
        "Gas (Frame)",
        "Gas/Liquid (Frame)",
        "Hydraulic",
        "Steam",
        "Water",
        "Wind"
      ],
      // eslint-disable-next-line
      rotatingPump: [
        "Diaphragm",
        "Centrifugal",
        "Gear",
        "Membrane",
        "Plunger",
        "Rotary",
        "Reciprocating",
        "Screw",
        "Vane"
      ],
      // eslint-disable-next-line
      rotatingProcess: [
        "Blower",
        "Conveyor",
        "Crusher",
        "Mill",
        "Mill Ball",
        "Mill Sag",
        "Mixer",
        "Fan",
        "Fan Centrifugal",
        "Fan Axial"
      ],
      // eslint-disable-next-line
      instrumentationValve: [
        "Actuator (Electrical)",
        "Actuator (Hydraulic)",
        "Actuator (Pneumatic)",
        "Blowdown",
        "Control",
        "MOV",
        "Positioner",
        "Shutdown",
        "Sequencing",
        "Solenoid"
      ],
      instrumentationAnalyser: [
        "CO2",
        "Conductivity",
        "Cylinder",
        "Denisty",
        "Gas Chromatograph",
        "H2S",
        "KVP",
        "Mercury",
        "Mositure",
        "Oil in H2O",
        "Oxygen",
        "PH",
        "Panel",
        "Probe"
      ],
      instrumentationTx: [
        "Conductivity",
        "DP",
        "Flow",
        "Humidity",
        "Level",
        "Limit",
        "Pressure",
        "Temperature",
        "Thermostat",
        "Thermowell",
        "Manifold",
        "Panel"
      ],
      instrumentationFlow: [
        "Coriolis",
        "DP",
        "Positive Displacement",
        "Electromagnetic",
        "Rotameters",
        "Thermal Mass",
        "Turbine",
        "Ultrasonic",
        "Variable Area",
        "Venturi",
        "Vortex"
      ],
      instrumentationLevel: [
        "Capacitance ",
        "Displacement",
        "Guided Microwave",
        "Liquid",
        "Magnetic",
        "Nuclear",
        "Radar",
        "Ultrasonic"
      ],
      // eslint-disable-next-line
      instrumentationSafety: [
        "Indicator",
        "Lamp",
        "Siren",
        "Horn",
        "Speaker",
        "Gas Sensor",
        "Gas Sensor Catalytic",
        "Gas Sensor IR Pt.",
        "Gas Sensor IR Im.",
        "Gas Sensor LOS",
        "Gas Sensor Portable",
        "Personal Gas Monitor",
        "Flame Detector",
        "Flame IR",
        "Flame UV",
        "Heat Detector",
        "Smoke Detector",
        "Smoke Detector Ion",
        "Smoke Detector Optical",
        "VESDA",
        "Power Supply",
        "Control Panel",
        "Fire and Gas Panel"
      ],
      // eslint-disable-next-line
      instrumentationGauge: [
        "Flow",
        "Level",
        "Mass",
        "Pressure",
        "Temperature"
      ],
      // eslint-disable-next-line
      mechanicalValve: [
        "Ball",
        "Blowdown",
        "Block and Bleed",
        "Butterfly",
        "Check",
        "Deluge",
        "Gate",
        "Globe",
        "Isolation",
        "Monoflange",
        "Needle",
        "Plug",
        "PRD",
        "PRD Disc",
        "Rapture",
        "Relief",
        "Vacuum Break",
        "Self Reg.",
        "Shutdown"
      ],
      // eslint-disable-next-line
      mechanicalAccu: [
        "Hydraulic",
        "Pneumatic"
      ],
      // eslint-disable-next-line
      mechanicalHeater: [
        "Burner",
        "Ignitor",
        "Gas Fired",
        "Liquid Heater",
        "Steam Heater"
      ],
      // eslint-disable-next-line
      mechanicalHVAC: [
        "AC Unit",
        "AC Split",
        "Chiller",
        "Condenser",
        "Damper",
        "Ducting",
        "Evaporator"
      ],
      // eslint-disable-next-line
      mechanicalCorrosion: [
        "Cathodic Protection"
      ],
      // eslint-disable-next-line
      mechanicalCrane: [
        "Davit",
        "Deck",
        "Gantry",
        "Jib",
        "Mobile",
        "Monorail",
        "Overhead",
        "Telescopic",
        "Tower",
        "Basket",
        "Break",
        "Gearbox",
        "Winch"
      ],
      // eslint-disable-next-line
      mechanicalVessel: [
        "Dryer",
        "Scrubber",
        "Seperator",
        "Strainer"
      ],
      // eslint-disable-next-line
      mechanicalHeatExchanger: [
        "Plate",
        "Plate Fin",
        "Shell",
        "Tube",
        "WHRU"
      ],
      // eslint-disable-next-line
      mechanicalFilter: [
        "Lube Oil",
        "Seal Oil",
        "Standard"
      ],
      // eslint-disable-next-line
      mechanicalPipe: [
        "Blind Flange",
        "Flame Arrester",
        "Flange",
        "Damper",
        "Drain",
        "Section",
        "Steel",
        "Copper",
        "PVC",
        "Shoe",
        "Strainer",
        "Support",
        "Vent"
      ],
      // eslint-disable-next-line
      mechanicalHose: [
        "General",
        "Hydraulic",
        "Fire Water",
        "Fuel",
        "HP",
        "LP",
        "Reel"
      ],
      // eslint-disable-next-line
      mechanicalFlare: [
        "Ignitor",
        "Stack",
        "Tip"
      ],
      // eslint-disable-next-line
      mechanicalTank: [
        "Fuel",
        "Lube Oil",
        "Seal Oil",
        "Water"
      ],
      // eslint-disable-next-line
      controlDCS: [
        "Master",
        "AI",
        "DI",
        "DO",
        "IO",
        "Comms"
      ],
      // eslint-disable-next-line
      controlSCADA: [
        "Master",
        "AI",
        "DI",
        "DO",
        "IO",
        "Comms"
      ],
      // eslint-disable-next-line
      controlMachine: [
        "Master",
        "AI",
        "DI",
        "DO",
        "IO",
        "Comms"
      ],
      // eslint-disable-next-line
      controlPLC: [
        "Master",
        "Remote",
        "AI",
        "DI",
        "DO",
        "IO",
        "Comms"
      ],
      // eslint-disable-next-line
      controlAPC: [
        "Master",
        "Remote",
        "AI",
        "DI",
        "DO",
        "IO",
        "Comms"
      ],
      // eslint-disable-next-line
      controlSafety: [
        "Fire Panel",
        "Fire & Gas Panel",
        "Safety Shutdown System",
        "HMI",
        "Power Supply"
      ],
      // eslint-disable-next-line
      controlRemote: [
        "Master",
        "Remote",
        "AI",
        "DI",
        "DO",
        "IO",
        "Comms"
      ],
      // eslint-disable-next-line
      controlMiscellaneous: [
        "Control Panel",
        "Relay Panel",
        "IP Panel",
        "HMI",
        "Thermostat",
        "Power Supply",
        "Filter"
      ],
      // eslint-disable-next-line
      civilBuilding: [
        "Lift",
        "Escalator",
        "Floor",
        "Shop",
        "Office",
        "Public",
        "House",
        "High Rise",
        "Rubbish",
        "Toilet",
        "Plumbing"
      ],
      // eslint-disable-next-line
      civilHydraulic : [
        "Bund",
        "Canal",
        "Drain",
        "Embankment",
        "Floodgate",
        "Pit",
        "Sea Dike",
        "Sump"
      ],
      // eslint-disable-next-line
      civilStructural: [
        "Berth",
        "Bridge",
        "Culvert",
        "Dam",
        "Fence",
        "Fire Wall",
        "Jetty",
        "Module",
        "Mooring Line",
        "Pipe Rack",
        "Tower",
        "Trench",
        "Tunnel",
        "Underpass",
        "Wharf"
      ],
      // eslint-disable-next-line
      civilTransportation: [
        "Bollard",
        "Floodway",
        "Freeway",
        "Highway",
        "Motorway",
        "Park Meter",
        "Parking",
        "Pavement",
        "Railway Crossing",
        "Road",
        "Sign",
        "Street",
        "Traffic Light"
      ],
      // eslint-disable-next-line
      commsAux: [
        "Amplifier",
        "Optical Fibre",
        "Sonar",
        "Radar",
        "Power Supply",
        "Filter"
      ],
      // eslint-disable-next-line
      commsAntenna: [
        "Array",
        "Dipole",
        "General",
        "GPS",
        "Helical",
        "HF",
        "Horn",
        "Isotropic",
        "Loop",
        "Monopole",
        "Parabolic",
        "Satellite",
        "WiFi"
      ],
      // eslint-disable-next-line
      commsPhone: [
        "Fixed",
        "Mobile",
        "PBX",
        "Public",
        "Satellite",
        "Smart",
        "VoIP"
      ],
      // eslint-disable-next-line
      commsRadio: [
        "Beacon",
        "Microwave",
        "HF",
        "UHF",
        "VHF"
      ],
      // eslint-disable-next-line
      commsNav: [
        "Aids System"
      ],
      // eslint-disable-next-line
      commsSecurity: [
        "CCTV Camera"
      ],
      // eslint-disable-next-line
      itHardware: [
        "Laptop",
        "Screen",
        "Speakers"
      ],
      // eslint-disable-next-line
      itNewtork: [
        "Extender",
        "Router",
        "Switch"
      ],
      // eslint-disable-next-line
      itSoftware: [
        "Licence",
        "Special"
      ],
      // eslint-disable-next-line
      fireAFS: [
        "AFS System",
        "Building Standpipe",
        "Gas Clean Agent System",
        "Gas Clean Agent Cylinder",
        "CO2 System",
        "CO2 Cylinder",
        "Fire Blanket",
        "Fire Monitor",
        "Fire Water System",
        "Foam System",
        "Foam Cylinder",
        "Foam Vessel",
        "Sprinkler System",
        "Sprinkler Nozzle"
      ],
      // eslint-disable-next-line
      fireExtinguisher: [
        "CO2",
        "Foam",
        "Powder",
        "Standard",
        "Water",
        "Wet Chemical"
      ],
      // eslint-disable-next-line
      firePFP: [
        "Fire Door",
        "Fire Wall"
      ],
      // eslint-disable-next-line
      systemSafety: [
        "BA",
        "Eye Wash Station",
        "First Aid Kit",
        "Lifejacket",
        "Liferaft",
        "Lifebuoy",
        "Mask",
        "Safety Shower",
        "Stretcher"
      ],
      // eslint-disable-next-line`
      systemPackage: [
        "Combined Cycle Generator",
        "Diesel Compressor",
        "Diesel Generator",
        "Diesel Pump",
        "Electric Motor Compressor",
        "Electric Motor Pump",
        "Gas Turbine Compressor",
        "Gas Turbine Generator",
        "Gas Engine Generator",
        "Steam Turbine Compressor",
        "Steam Turbine Generator",
        "Wind Turbine Generator"
      ],
      // eslint-disable-next-line`
      systemMobile: [
        "Bus",
        "Car",
        "Diesel Air Compressor",
        "Diesel Generator",
        "Diesel Pump Unit",
        "Dump Truck",
        "Excavators",
        "Forklift",
        "Lighting Towers",
        "Smooth Drum Rollers",
        "Shuttle Bus",
        "Trailer",
        "Truck",
        "Van",
        "Wheel Loader"
      ]
    };
  }
};
